import { render, staticRenderFns } from "./InvoiceDetailDialog.vue?vue&type=template&id=2ce108c6"
import script from "./InvoiceDetailDialog.vue?vue&type=script&lang=js"
export * from "./InvoiceDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports